import { UserRole } from '@crm/shared';

export type RoleLike = UserRole | 'ADMIN' | 'MANAGER' | 'SELLER';

export type Permission =
  | 'leads.read'
  | 'leads.create'
  | 'leads.update'
  | 'leads.delete'
  | 'campaigns.read'
  | 'campaigns.send'
  | 'campaigns.delete'
  | 'users.manage'
  | 'audit.read'
  | 'financial.read'
  | 'prospecting.read'
  | 'proposals.manage';

const matrix: Record<UserRole, ReadonlySet<Permission>> = {
  [UserRole.ADMIN]: new Set<Permission>([
    'leads.read',
    'leads.create',
    'leads.update',
    'leads.delete',
    'campaigns.read',
    'campaigns.send',
    'campaigns.delete',
    'users.manage',
    'audit.read',
    'financial.read',
    'prospecting.read',
    'proposals.manage',
  ]),
  [UserRole.MANAGER]: new Set<Permission>([
    'leads.read',
    'leads.create',
    'leads.update',
    'leads.delete',
    'campaigns.read',
    'campaigns.send',
    'prospecting.read',
  ]),
  [UserRole.SELLER]: new Set<Permission>([
    'leads.read',
    'leads.create',
    'leads.update',
    'campaigns.read',
  ]),
};

export function can(role: RoleLike | null | undefined, permission: Permission): boolean {
  if (!role) {
    return false;
  }
  return matrix[role as UserRole]?.has(permission) ?? false;
}
